<template>
  <div style="padding-bottom: 70px">
    <div style="text-align: center; position: relative" class="py-2 mb-3">
      <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
      <div style="position: absolute; right: 15px; top: 15px">
        <v-chip
          class="px-3 py-1"
          @click="searchModal = true"
          :close="search ? true : false"
          small
          color="#0A4EA2"
          text-color="white"
          @click:close="clearSearch"
          >{{ search ? search : "ค้นหาสีด้วยรหัส" }}</v-chip
        >
      </div>
    </div>
    <div>
      <v-container class="Kanit">
        <div class="text-center">
          <h2 class="mb-3" style="color: #0a4ea2">กรุณาเลือกโทนสีที่คุณสนใจ</h2>
        </div>

        <v-row class="px-9">
          <v-col
            cols="3"
            v-for="(mainshade, k) in allmainshade"
            :key="mainshade.colorcode"
            class="pa-1"
          >
            <!-- <div
              :style="`background-color: rgb(${mainshade.mainshade_rgb}); width:100%;height: 60px;`"
            ></div>-->

            <v-card
              @click="changeMainShade(k)"
              v-ripple
              :elevation="0"
              class="colorcard"
              style="border-radius: 10px"
            >
              <div
                class="pa-2"
                :style="`background-color: rgb(${mainshade.mainshade_rgb}); height: 65px`"
              >
                <div
                  class="Kanit px-3 textswap"
                  :style="'display: table-cell;color:darkgrey;border-radius: 15px; background-color: white;font-weight: 600;'"
                >
                  {{ mainshade.mainshade_colorcode }}
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="secondloading">
      <div class="mt-8 text-center">
        <v-progress-circular
          color="primary"
          indeterminate
          size="50"
        ></v-progress-circular>
      </div>
    </div>
    <div v-else class="mx-2 mt-3">
      <div
        :class="`pa-1 pt-0`"
        style="width: 12.5%; display: inline-block"
        v-for="shade in secondshadeFilter"
        :key="shade.id"
        @click="changeSecondShade(shade)"
      >
        <div
          :class="`${selectedShade == shade.rgb ? 'active' : ''} pa-1`"
          :style="`border-radius: 4px;width:100%;height: 55px;background-color:rgb(${shade.rgb});transition: all 0.2s ease-in-out;position:relative;`"
        >
          <div
            class="Kanit px-1 textswap"
            :style="'font-size: 8px;display: table-cell;color:darkgrey;border-radius: 15px; background-color: white;font-weight: 600;'"
          >
            {{ shade.colorcode }}
          </div>
        </div>
      </div>
    </div>
    <transition name="slide">
      <div
        v-if="selectedShade && selectedShade != 'colorworld'"
        :key="selectedShade"
        class="proceedbtn"
      >
        <!-- {{ rgbToHex(selectedShade) }} -->
        <div
          v-ripple
          tile
          :style="`height: 65px;font-size: 30px;background-color: ${
            selectedShade ? 'rgb(' + selectedShade + ')' : ''
          }`"
          :disabled="!selectedShade"
          class="Kanit proceedbtn myshadow"
          block
          @click="confirmColor"
        >
          <div v-if="saveloading">
            <div
              :style="`margin-top: 5px;font-size: 28px;color:${
                $options.filters.setContrast(selectedShade).text
              };`"
              v-if="saveloading"
            >
              <v-progress-circular
                indeterminate
                size="40"
              ></v-progress-circular>
            </div>
          </div>
          <div
            v-else
            :style="`
                margin-top: 5px;
                color: darkgrey;
                font-size: 23px;
                background-color: white;
                display: inline-block;
                border-radius: 13px;`"
            class="px-4"
          >
            ยืนยัน
          </div>
        </div>
      </div>
    </transition>
    <v-dialog v-model="searchModal">
      <div class="px-4 Kanit">
        <v-text-field
          style="border-radius: 17px"
          placeholder="กรุณาใส่เฉดสีที่ต้องการ"
          outlined
          solo
          v-model="inputsearch"
        >
          <template v-slot:append>
            <v-btn :loading="searchloading" @click="onSearch" icon outlined>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      saveloading: false,
      selectedShade: "",
      inputsearch: "",
      shadeindex: 0,
      serverUrl: "https://communitybotbyzwizai.herokuapp.com/",
      loading: false,
      secondloading: false,
      allmainshade: [],
      secondshade: [],
      selectedColorCode: "",
      searchModal: false,
      searchloading: false,
      search: "",
      searchData: [],
    };
  },
  async mounted() {
    await this.getMainShade();
    await this.getSecondShade();
  },
  computed: {
    secondshadeFilter() {
      if (this.search.length) return this.searchData;
      else return this.secondshade;
    },
  },
  methods: {
    clearSearch() {
      this.search = "";
      this.inputsearch = "";
    },
    onSearch() {
      this.search = this.inputsearch;
      this.searchloading = true;
      var vm = this;
      axios
        .get(this.serverUrl + "toasearchcolorworld", {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: { colors: this.search },
        })
        .then(async (response) => {
          this.searchloading = false;
          if (response.data && response.data.responsecode == 400) {
            await vm.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          this.searchData = response.data.data;
          this.searchModal = false;
          this.searchloading = false;
        });
    },
    changeSecondShade(shade) {
      this.selectedShade = shade.rgb;
      this.selectedColorCode = shade.colorcode;
    },
    confirmColor() {
      if (!this.saveloading) {
        this.saveloading = true;
        this.$emit("confirmColor", {
          shade: this.selectedShade,
          colorcode: this.selectedColorCode,
        });
      }
    },
    rgbToHex(rgb) {
      if (rgb) {
        var myrgb = rgb.split(",");
      } else return "";
      return (
        "#" +
        (
          (1 << 24) +
          (parseInt(myrgb[0]) << 16) +
          (parseInt(myrgb[1]) << 8) +
          parseInt(myrgb[2])
        )
          .toString(16)
          .slice(1)
      );
    },
    changeMainShade(k) {
      this.clearSearch();
      this.shadeindex = k;
      this.getSecondShade();
    },
    getMainShade() {
      var vm = this;
      return new Promise((resolve, reject) => {
        axios
          .get(this.serverUrl + "toacolorworldmainshade", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              main_category: "Decorative Coatings",
              category: "EXT",
            },
          })
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (response.data.responsecode == 200) {
              vm.allmainshade = response.data.data;
              resolve();
            }
          });
      });
    },
    getSecondShade() {
      var vm = this;
      vm.secondloading = true;
      return new Promise((resolve, reject) => {
        axios
          .get(this.serverUrl + "toacolorworldsecondshade", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              mainshade_colorcode: this.allmainshade[this.shadeindex]
                .mainshade_colorcode,
            },
          })
          .then(async (response) => {
            vm.secondloading = false;
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              this.secondshade = response.data.data;
            }
          });
      });
    },
    closeColorWorld() {
      this.$emit("closeColorWorld");
    },
  },
  filters: {
    setContrast(myrgb) {
      var rgb = myrgb.split(",");

      // Randomly update colours
      const brightness = Math.round(
        (parseInt(rgb[0]) * 299 +
          parseInt(rgb[1]) * 587 +
          parseInt(rgb[2]) * 114) /
          1000
      );
      const textColour = brightness > 185 ? "black" : "white";
      const backgroundColour =
        "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")";
      return { text: textColour, background: backgroundColour };
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 50%;
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.arrow {
  border: solid white;
  border-width: 0 8px 8px 0;
  display: inline-block;
  padding: 8px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}
.active {
  transform: scale(1.4);
  z-index: 2;
  -webkit-box-shadow: 2px 4px 8px 0px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: 2px 4px 8px 0px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 4px 8px 0px rgba(0, 0, 0, 0.65);
}
// .proceedbtn {
//   left: 50%;
//   transform: translate(-50%, 0);
//   position: fixed;
//   bottom: 0px;
//   border-radius: 10px 10px 0px 0px;
//   text-align: center;
//   width: 90%;
// }
.textbtn {
  background: inherit;
  background-clip: text;
}
.slide-enter-active {
  transition: all 0.25s ease;
}
.slide-leave-active {
  transition: all 0.7s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(70px);
  opacity: 50;
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
}
</style>